import {
  POST_CONTENT_CHANGE, POST_DAUM_LIKE_CATEGORY_CHANGE,
  POST_PASSWORD_CHANGE, POST_PUBLISHED_CHANGE,
  POST_SLOGAN_CHANGE, POST_TITLE_CHANGE,
  POST_VISIBILITY_CHANGE, POST_ACCEPT_COMMENT_CHANGE,
  POST_RECAPTCHA_VALUE_CHANGE,
  POST_CCL_CHANGE, POST_CATEGORY_CHANGE,
  POST_TAG_ADD, POST_TAG_REMOVE, POST_TAG_UPDATE,
  POST_THUMBNAIL_CHANGE,
  DRAFT_COUNT_UPDATE, UPDATE_TITLE_AND_CONTENT,
  INCREASE_UPLOAD_PROGRESS_COUNT, DECREASE_UPLOAD_PROGRESS_COUNT, POST_SET_DRAFT_SEQUENCE, POST_TAGS_SET
} from "../constants/ActionTypes";
import {adjustVisibility, getAttachmentKeysFromContent} from "../lib/PostUtils"
import axios from "axios"
import {postChanged} from "./index"

export const changeCategory = (categoryId, viewChanel) => ({
  type: POST_CATEGORY_CHANGE,
  categoryId,
  viewChanel
});

export const changeContent = (content) => ({
  type: POST_CONTENT_CHANGE,
  content
});

export const changeTitle = (title) => ({
  type: POST_TITLE_CHANGE,
  title
});

export const changeVisibility = visibility => ({
  type: POST_VISIBILITY_CHANGE,
  visibility
});

export const changeGoogleRecaptchaValue = (recaptchaValue) => ({
  type: POST_RECAPTCHA_VALUE_CHANGE,
  recaptchaValue
});

export const changeSlogan = slogan => ({
  type: POST_SLOGAN_CHANGE,
  slogan
});

export const changePublished = published => ({
  type: POST_PUBLISHED_CHANGE,
  published
});

export const changeDaumLikeCategory = daumLikeCategory => ({
  type: POST_DAUM_LIKE_CATEGORY_CHANGE,
  daumLikeCategory
});

export const changePostPassword = password => ({
  type: POST_PASSWORD_CHANGE,
  password
});

export const changeAcceptComment = acceptComment => ({
  type: POST_ACCEPT_COMMENT_CHANGE,
  acceptComment
});

export const changeCCL = (cclCommercial, cclDerive) => ({
  type: POST_CCL_CHANGE,
  cclCommercial, cclDerive
});

export const addTag = (tag) => ({
  type: POST_TAG_ADD,
  tag
});

export const removeTag = (tag) => ({
  type: POST_TAG_REMOVE,
  tag
});

export const updateTag = (orgTag, tag) => ({
  type: POST_TAG_UPDATE,
  orgTag, tag
});

export const setTags = (tags) => ({
  type: POST_TAGS_SET,
  tags
});

export const changeThumbnail = (thumbnail) => ({
  type: POST_THUMBNAIL_CHANGE,
  thumbnail
});

export const updateDraftCount = (count) => ({
  type: DRAFT_COUNT_UPDATE,
  count
});

export const updateTitleAndContent = (title, content) => ({
  type: UPDATE_TITLE_AND_CONTENT,
  title,
  content
});

export const increaseUploadProgressCount = () => ({
  type: INCREASE_UPLOAD_PROGRESS_COUNT
});

export const decreaseUploadProgressCount = () => ({
  type: DECREASE_UPLOAD_PROGRESS_COUNT
});

export const publishPost = (post, postType, postCategoryVisibility, onPublishing, draftSequence) => {
  return dispatch => {
    onPublishing(true)
    const content = post.content;
    const attachments = getAttachmentKeysFromContent(content);
    const url = appInfo.manageUrl + (post.id > 0 ? `/post/${post.id}.json` : `/posts.json`);
    const method = post.id > 0 ? 'put' : 'post';

    const data = {
      id: post.id,
      title: post.title,
      content: content,
      slogan: post.slogan,
      visibility: adjustVisibility(post.visibility, postCategoryVisibility),
      category: post.category,
      tag: post.tags.join(','),
      acceptComment: post.acceptComment,
      published: post.published,
      password: post.password,
      uselessMarginForEntry: post.uselessMargin,
      daumLike: post.daumLikeCategory,
      cclCommercial: post.cclCommercial,
      cclDerive: post.cclDerive,
      thumbnail: post.thumbnail,
      type: postType,
      attachments: attachments,
      recaptchaValue : post.recaptchaValue,
      draftSequence: draftSequence
    };

    axios({
      url: url,
      method: method,
      data: data
    })
      .then(data => {
        dispatch(postChanged(false))
        const returnUrl = window.appInfo.returnUrl;
        if (returnUrl === 'CLOSEME') {
          if (opener && opener.reloadPost) {
            opener.reloadPost();
          }
          window.close();
        } else if (!returnUrl) {
          location.href = `${appInfo.manageUrl}/${postType}s`;
        } else {
          location.href = window.appInfo.returnUrl;
        }
      })
      .catch(e => {
        if (e.response.data) {
          if (e.response.data.message) {
            alert(e.response.data.message);
          } else {
            alert(e.response.data)
          }

        } else {
          alert("오류가 발생했습니다.")
        }
        console.error(e, e.response)
      })
      .finally(() => {
        onPublishing(false)
      })
  }
}

export const setDraftSequence = (draftSequence) => ({
  type: POST_SET_DRAFT_SEQUENCE,
  draftSequence
});
